import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddPlayersTemplateModal from '../../AddPlayersTemplateModal';
import { getLiveTemplateFile } from '../../../../selectors/teams';
import { aGetLiveTemplateFileRequest, aSaveLiveTemplateRequest } from '../../../../reducers';

const mapToProps = (state) => ({
  liveTemplateFile: getLiveTemplateFile(state),
});
const actionsToProps = (dispatch) => ({
  getLiveTemplateFileRequest: (payload) => dispatch(aGetLiveTemplateFileRequest(payload)),
  saveLiveTemplate: (payload) => dispatch(aSaveLiveTemplateRequest(payload)),
});
class AddLiveTemplateSection extends Component {
  componentDidMount() {
    this.props.getLiveTemplateFileRequest();
  }

  render() {
    return (
      <AddPlayersTemplateModal
        playersTemplateFile={this.props.liveTemplateFile}
        applyPlayersTemplatePreview={this.props.saveLiveTemplate}
        leagues={this.props.leagues}
        setOpenModal={this.props.setOpenModal}
        activeModal={this.props.activeModal}
        closeModal={this.props.closeModal}
        titleName="New Live Template"
        selectDescription="Select the competition to apply live template"
        saveBtnLabel="Save"
      />
    );
  }
}
export default connect(mapToProps, actionsToProps)(AddLiveTemplateSection);
